import { useContext } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { status, encryptURL } from 'utils/functions';
import { AuthContext } from 'contexts/AuthContext';
import { ExpedicoesContext } from 'contexts/ExpedicoesContext';
import Container from 'components/Container';
import Stepper from 'components/Stepper';
import Header from 'components/Header';
import Lotes from './Steps/Lotes';
import Itens from './Steps/Itens';
import styles from './styles';

const renderComponent = (props) => {
  switch (props?.index) {
    case 0:
      return <Lotes {...props} />;
    case 1:
      return <Itens {...props} attribute="quantidade_separada" />;
    case 2:
      return <Itens {...props} attribute="quantidade_embalada" />;
    case 3:
      return <Itens {...props} attribute="quantidade_volumada" />;
    default:
      return null;
  }
};

const Expedicoes = () => {
  const navigate = useNavigate();
  const titulo = 'Expedições';
  const { user } = useContext(AuthContext);
  const {
    lotesLoading,
    getLotes,
    separacaoLoading,
    getSeparacao,
    embalagemLoading,
    getEmbalagem,
    volumeLoading,
    getVolume,
  } = useContext(ExpedicoesContext);

  const steps = [
    {
      titulo: 'Lotes',
      visible: true,
      loading: lotesLoading,
      fetch: (params, cb) => getLotes({ params, cb }),
      ...status?.LOTES,
      actions: [
        {
          name: 'Separar',
          icon: status?.SEPARACAO?.icon,
          show: user?.configuracoes?.Expedicao?.separacao,
          action: (arr) =>
            navigate(`/app/Expedicoes/Separacao/${encryptURL(arr)}`),
        },
        {
          name: 'Embalar',
          icon: status?.EMBALAGEM?.icon,
          show: user?.configuracoes?.Expedicao?.embalagem,
          action: (arr) =>
            navigate(`/app/Expedicoes/Embalagem/${encryptURL(arr)}`),
        },
        {
          name: 'Volumar',
          icon: status?.VOLUME?.icon,
          show: user?.configuracoes?.Expedicao?.volume,
          action: (arr) =>
            navigate(`/app/Expedicoes/Volume/${encryptURL(arr)}`),
        },
      ],
    },
    {
      titulo: 'Separação',
      loading: separacaoLoading,
      visible: user?.configuracoes?.Expedicao?.separacao,
      fetch: (params, cb) => getSeparacao({ params, cb }),
      ...status?.SEPARACAO,
    },
    {
      titulo: 'Embalagem',
      loading: embalagemLoading,
      visible: user?.configuracoes?.Expedicao?.embalagem,
      fetch: (params, cb) => getEmbalagem({ params, cb }),
      ...status?.EMBALAGEM,
    },
    {
      titulo: 'Volume',
      loading: volumeLoading,
      visible: user?.configuracoes?.Expedicao?.volume,
      fetch: (params, cb) => getVolume({ params, cb }),
      ...status?.VOLUME,
    },
  ];

  return (
    <Container>
      <Header titulo={titulo} />
      <Box sx={styles?.container}>
        {steps
          ?.filter((f) => Boolean(f?.visible))
          ?.map((props, index) => (
            <Stepper
              {...props}
              index={index}
              key={index?.toString()}
              renderComponent={renderComponent}
            />
          ))}
      </Box>
    </Container>
  );
};

export default Expedicoes;
